"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasKistlerIDProvider = exports.convertLockoutEndToBooleans = exports.convertEnabledBooleanToValues = exports.resetUserPassword = exports.deleteUser = exports.changeUserPassword = exports.updateUser = exports.createUser = exports.fetchUser = exports.fetchUsers = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _reduxBatchedActions = require("redux-batched-actions");

var _actions = require("skybase-ui/skybase-core/base/actions");

var _actions2 = require("../actions");

var _rest = require("../rest");

var _actions3 = require("./actions");

var _constants = require("./constants");

var _constants2 = require("../constants");

var _utils = require("../utils");

var _usersI18n = require("./users-i18n");

var _messagesI18n = require("../messages-i18n");

var NORMAL = _constants2.STATES.NORMAL,
    LOADING = _constants2.STATES.LOADING;

var fetchUsers = function fetchUsers(pageSize, pageNumber, _) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      var _yield$getUsersApi, _yield$getUsersApi$re, records, listConfig;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              dispatch((0, _actions3.changeListUsersState)(LOADING));
              _context.next = 4;
              return (0, _rest.getUsersApi)(pageSize, pageNumber);

            case 4:
              _yield$getUsersApi = _context.sent;
              _yield$getUsersApi$re = _yield$getUsersApi.records;
              records = _yield$getUsersApi$re === void 0 ? [] : _yield$getUsersApi$re;
              listConfig = (0, _objectWithoutProperties2.default)(_yield$getUsersApi, ["records"]);
              dispatch((0, _reduxBatchedActions.batchActions)([(0, _actions3.changeListUsersState)(NORMAL), (0, _actions3.setUsers)(records), (0, _actions3.changeUserListConfig)(listConfig)]));
              _context.next = 16;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              dispatch((0, _actions3.changeListUsersState)(NORMAL)); // todo handle errors

              console.log(_context.t0);
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _(_messagesI18n.messages.error),
                message: _(_usersI18n.messages.errorDuringUsersFetch)
              }));

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 11]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.fetchUsers = fetchUsers;

var fetchUser = function fetchUser(id, _) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (0, _rest.getUserApi)(id);

            case 3:
              return _context2.abrupt("return", _context2.sent);

            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
              // todo handle errors
              console.log(_context2.t0);
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _(_messagesI18n.messages.error),
                message: _(_usersI18n.messages.errorDuringUsersFetch)
              }));
              return _context2.abrupt("return", {});

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 6]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.fetchUser = fetchUser;

var createUser = function createUser(user, _ref3, _) {
  var pageSize = _ref3.pageSize,
      pageNumber = _ref3.pageNumber;
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(dispatch) {
      var errorCode;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              dispatch((0, _actions3.changeCreateUserState)(LOADING));
              _context3.next = 4;
              return (0, _rest.createUserApi)(user);

            case 4:
              dispatch((0, _reduxBatchedActions.batchActions)([(0, _actions3.changeCreateUserState)(NORMAL), (0, _actions3.clearCreateUserParams)(), (0, _actions.closeModal)()]));
              dispatch((0, _actions2.showSuccessToastFactory)({
                title: _(_messagesI18n.messages.success),
                message: _(_usersI18n.messages.userSuccessfullyCreated)
              }));
              dispatch(fetchUsers(pageSize, pageNumber, _));
              _context3.next = 19;
              break;

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](0);
              dispatch((0, _actions3.changeCreateUserState)(NORMAL));
              errorCode = (0, _utils.getErrorCode)(_context3.t0);
              _context3.t1 = errorCode;
              _context3.next = _context3.t1 === 409 ? 16 : 18;
              break;

            case 16:
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _messagesI18n.messages.error,
                message: _usersI18n.messages.userAlreadyExists
              }));
              return _context3.abrupt("break", 19);

            case 18:
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _messagesI18n.messages.error,
                message: _usersI18n.messages.errorDuringUserCreation
              }));

            case 19:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 9]]);
    }));

    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
};

exports.createUser = createUser;

var updateUser = function updateUser(user, _ref5, _) {
  var pageSize = _ref5.pageSize,
      pageNumber = _ref5.pageNumber;
  return /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(dispatch) {
      var errors;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              dispatch((0, _actions3.changeUpdateUserState)(LOADING));
              _context4.next = 4;
              return (0, _rest.updateUserApi)(user);

            case 4:
              dispatch((0, _reduxBatchedActions.batchActions)([(0, _actions3.changeUpdateUserState)(NORMAL) // clearUpdateUserParams(),
              ]));
              dispatch((0, _actions2.showSuccessToastFactory)({
                title: _(_messagesI18n.messages.success),
                message: _(_usersI18n.messages.userSuccessfullyUpdated)
              }));
              dispatch(fetchUsers(pageSize, pageNumber, _));
              _context4.next = 14;
              break;

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](0);
              errors = _context4.t0.errors;
              dispatch((0, _actions3.changeUpdateUserState)(NORMAL));

              if (errors) {
                (0, _utils.handleErrors)({
                  errors: errors
                }, dispatch);
              } else {
                dispatch((0, _actions2.showErrorToastFactory)({
                  title: _(_messagesI18n.messages.error),
                  message: _(_usersI18n.messages.errorDuringUserUpdate)
                }));
              }

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 9]]);
    }));

    return function (_x4) {
      return _ref6.apply(this, arguments);
    };
  }();
};

exports.updateUser = updateUser;

var changeUserPassword = function changeUserPassword(user, _) {
  return /*#__PURE__*/function () {
    var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(dispatch) {
      var errorCode;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              dispatch((0, _actions3.changePasswordUserState)(LOADING));
              _context5.next = 4;
              return (0, _rest.changeUserPasswordApi)(user);

            case 4:
              dispatch((0, _reduxBatchedActions.batchActions)([(0, _actions3.changePasswordUserState)(NORMAL), (0, _actions3.clearPasswordUserParams)()]));
              dispatch((0, _actions2.showSuccessToastFactory)({
                title: _(_messagesI18n.messages.success),
                message: _(_usersI18n.messages.userPasswordSuccessfullyChanged)
              }));
              _context5.next = 18;
              break;

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);
              dispatch((0, _actions3.changePasswordUserState)(NORMAL)); // todo handle errors

              errorCode = (0, _utils.getErrorCode)(_context5.t0);
              _context5.t1 = errorCode;
              _context5.next = _context5.t1 === 400 ? 15 : 17;
              break;

            case 15:
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _(_messagesI18n.messages.error),
                message: _(_usersI18n.messages.errorPasswordNotChanged)
              }));
              return _context5.abrupt("break", 18);

            case 17:
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _(_messagesI18n.messages.error),
                message: _(_usersI18n.messages.errorDuringUserPasswordChange)
              }));

            case 18:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 8]]);
    }));

    return function (_x5) {
      return _ref8.apply(this, arguments);
    };
  }();
};

exports.changeUserPassword = changeUserPassword;

var deleteUser = function deleteUser(id, _ref9, _) {
  var pageSize = _ref9.pageSize,
      pageNumber = _ref9.pageNumber;
  return /*#__PURE__*/function () {
    var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(dispatch) {
      var errors;
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return (0, _rest.deleteUserApi)(id);

            case 3:
              dispatch((0, _actions3.clearAllUserForms)());
              dispatch((0, _actions2.showSuccessToastFactory)({
                title: _(_messagesI18n.messages.success),
                message: _(_usersI18n.messages.userSuccessfullyDeleted)
              }));
              dispatch(fetchUsers(pageSize, pageNumber, _));
              _context6.next = 12;
              break;

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);
              errors = _context6.t0.errors;

              if (errors) {
                (0, _utils.handleErrors)({
                  errors: errors
                }, dispatch);
              } else {
                dispatch((0, _actions2.showErrorToastFactory)({
                  title: _(_messagesI18n.messages.error),
                  message: _(_usersI18n.messages.errorDuringUserDeletion)
                }));
              }

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 8]]);
    }));

    return function (_x6) {
      return _ref10.apply(this, arguments);
    };
  }();
};

exports.deleteUser = deleteUser;

var resetUserPassword = function resetUserPassword(id, _) {
  return /*#__PURE__*/function () {
    var _ref12 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(dispatch) {
      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return (0, _rest.resetPasswordApi)(id);

            case 3:
              dispatch((0, _actions2.showSuccessToastFactory)({
                title: _(_messagesI18n.messages.success),
                message: _(_usersI18n.messages.userPasswordSuccessfullyReset)
              }));
              _context7.next = 10;
              break;

            case 6:
              _context7.prev = 6;
              _context7.t0 = _context7["catch"](0);
              // todo handle errors
              console.log(_context7.t0);
              dispatch((0, _actions2.showErrorToastFactory)({
                title: _(_messagesI18n.messages.error),
                message: _(_usersI18n.messages.errorDuringPasswordReset)
              }));

            case 10:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[0, 6]]);
    }));

    return function (_x7) {
      return _ref12.apply(this, arguments);
    };
  }();
};
/**
 * Convert a boolean to an appropriate value.
 * - If true, the value will be reset to "null".
 * - If false, the value will be the default LOCKOUT_END_VALUE.
 * - If null (when directly set from the rest API), the value stays "null".
 * - If string (only date string), parse the date and check if:
 *    - smaller then current time -> return null
 *    - bigger -> return the date string itself.
 * @param enabled
 * @returns {null|String}
 */


exports.resetUserPassword = resetUserPassword;

var convertEnabledBooleanToValues = function convertEnabledBooleanToValues(enabled) {
  if (typeof enabled === 'boolean') {
    return enabled ? null : _constants.LOCKOUT_END_VALUE;
  }

  if (enabled === null) {
    return null;
  }

  var lockoutEndDate = new Date(enabled);

  if (lockoutEndDate.getDate()) {
    var dateNow = new Date();
    return lockoutEndDate < dateNow ? null : enabled;
  }

  return null;
};
/**
 * Converts the lockoutEnd param to a boolean.
 * - If it is a boolean already, return it as it is.
 * - If it is null, return true.
 * - If string (only date string), parse the date and check if:
 *    - smaller then current time -> return true
 *    - bigger -> return false
 * @param lockoutEnd
 * @returns {boolean}
 */


exports.convertEnabledBooleanToValues = convertEnabledBooleanToValues;

var convertLockoutEndToBooleans = function convertLockoutEndToBooleans(lockoutEnd) {
  if (typeof lockoutEnd === 'boolean') {
    return lockoutEnd;
  }

  if (lockoutEnd === null) {
    return true;
  }

  var lockoutEndDate = new Date(lockoutEnd);

  if (lockoutEndDate.getDate()) {
    var dateNow = new Date();
    return lockoutEndDate < dateNow;
  }

  return true;
}; // Check if the provider is a KistlerID.
// Providers can be an array of strings, or a single string.


exports.convertLockoutEndToBooleans = convertLockoutEndToBooleans;

var hasKistlerIDProvider = function hasKistlerIDProvider() {
  var providers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (!providers) {
    return false;
  }

  if (typeof providers === 'string') {
    return providers === _constants.KISTLER_ID_AUTHENTICATION_PROVIDER;
  }

  return providers.findIndex(function (provider) {
    return provider === _constants.KISTLER_ID_AUTHENTICATION_PROVIDER;
  }) !== -1;
};

exports.hasKistlerIDProvider = hasKistlerIDProvider;
//# sourceMappingURL=utils.js.map